<template>
    <div class="row">
        <div class="col-md-12">
            <h3 class="mb-0">Price List</h3>
            <p>Sort by category, search, or browse all below.</p>

            <div class="row">
                <div class="col-sm-12 col-md-3 pb-2">
                    <select
                        class="form-control mb-1"
                        v-model="selectedPriceList"
                        @change="changePriceList"
                    >
                        <option
                            v-for="(pricelist, index) in pricelistsTable"
                            :key="index"
                            :value="pricelist.id"
                        >
                            {{ pricelist.pricelist_name }}
                        </option>
                    </select>
                </div>
                <div class="col-sm-12 col-md-3 pb-2">
                    <select
                        class="form-control"
                        v-model="searchCategory"
                        @change="selectCategory"
                    >
                        <option value="all">ALL</option>
                        <template
                            v-for="(category, idx) in allCategories"
                            :key="idx"
                        >
                            <option :value="category">{{ category }}</option>
                        </template>
                    </select>
                </div>
                <div class="col-sm-12 col-md-3 pb-2">
                    <div class="form-group">
                        <div class="input-group search-field">
                            <input
                                class="form-control"
                                type="text"
                                @input="onChange"
                                placeholder="Search the store"
                                v-model="searchTerm"
                                autocomplete="off"
                            />
                            <div class="input-group-prepend">
                                <span class="input-group-text"
                                    ><i class="fas fa-search"></i
                                ></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3 text-right">
                    <span
                        class="add-button btn btn-action"
                        @click="openModalExport()"
                    >
                        Export To PDF/Excel
                    </span>
                </div>
            </div>

            <div class="row mx-0 mt-3">
                <div class="col-md-12 p-0">
                    <table
                        class="table table-responsive table-striped border-bottom"
                    >
                        <thead class="thead-light header-sticky">
                            <tr>
                                <th>SKU</th>
                                <th>Product Name</th>
                                <th>Available</th>
                                <th class="text-right">MSRP</th>
                                <th class="text-right">MAP</th>
                                <th class="text-right">MTP</th>
                                <th class="text-right">Cost</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="pricelist in filteredPricelists"
                                :key="pricelist.id"
                            >
                                <td>{{ pricelist.sku }}</td>
                                <td>{{ pricelist.product_name }}</td>
                                <td>{{ pricelist.available_quantity }}</td>
                                <td class="text-right">
                                    {{
                                        pricelist.msrp == ""
                                            ? ""
                                            : "$" +
                                              $filters.moneyFormat(
                                                  pricelist.msrp
                                              )
                                    }}
                                </td>
                                <td class="text-right">
                                    {{
                                        pricelist.map == ""
                                            ? ""
                                            : "$" +
                                              $filters.moneyFormat(
                                                  pricelist.map
                                              )
                                    }}
                                </td>
                                <td class="text-right">
                                    {{
                                        pricelist.mtp == ""
                                            ? ""
                                            : "$" +
                                              $filters.moneyFormat(
                                                  pricelist.mtp
                                              )
                                    }}
                                </td>
                                <td class="text-right">
                                    {{
                                        pricelist.price == 0
                                            ? ""
                                            : "$" +
                                              $filters.moneyFormat(
                                                  pricelist.price
                                              )
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- Export modal -->
        <b-modal
            v-model="modalExport"
            :title="'Export to PDF/Excel'"
            class="mt-5"
            hide-footer
        >
            <ExportModal
                v-if="modalExport"
                :modal-data="modalData"
                @close-modal="closeModalExport"
            />
        </b-modal>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

import ExportModal from "./modals/ExportModal.vue";

export default {
    props: [],
    emits: [],
    components: {
        ExportModal,
    },
    setup() {
        const store = useStore();

        let user = computed(function () {
            return store.state.user;
        });
        let pricelists = computed(function () {
            return store.state.pricelists;
        });
        let allCategories = computed(function () {
            return store.state.allCategories;
        });
        let filteredPricelists = computed(function () {
            return store.state.filteredPricelists;
        });
        let currentLocation = computed(function () {
            return store.state.currentLocation;
        });
        let dealerPriceLists = computed(function () {
            return store.state.dealerPriceLists;
        });

        let selectedStatePriceList = computed(function () {
            return store.state.selectedStatePriceList;
        });

        let pricelistsTable = computed(function () {
            return store.state.pricelistsTable;
        });

        function getPriceListTable() {
            store.dispatch("getPricelistsTable", {});
        }

        function getAllPricelists(currentLocation) {
            store.dispatch("getAllPricelists", {
                pricelist_id: currentLocation.pricelist_id,
            });
        }

        function getAllCategories(pricelist_id) {
            store.dispatch("getAllCategories", {
                pricelist_id: pricelist_id,
            });
        }

        function searchPricelist(val) {
            store.dispatch("searchPricelist", val);
        }

        function getDealerPriceLists(currentLocationId) {
            store.dispatch("getDealerPriceLists", {
                location_id: currentLocationId,
            });
        }

        onMounted(() => {});

        return {
            store,
            user,
            pricelists,
            allCategories,
            filteredPricelists,
            currentLocation,
            dealerPriceLists,
            selectedStatePriceList,
            pricelistsTable,
            getAllPricelists,
            getAllCategories,
            searchPricelist,
            getDealerPriceLists,
            getPriceListTable,
        };
    },
    data() {
        return {
            searchTerm: "",
            searchCategory: "all",
            orders: JSON.parse(localStorage.getItem("orders")),
            modalExport: false,
            modalData: [],
            selectedPriceList: null,
        };
    },
    computed: {},
    mounted() {
        this.getAllCategories(this.currentLocation, this.user);
        this.getPriceListTable();
    },
    methods: {
        onChange() {
            this.searchCategory = "";
            this.searchPricelist({
                category: false,
                searchTerm: this.searchTerm,
            });
        },
        selectCategory() {
            this.searchTerm = "";
            this.searchPricelist({
                category: true,
                searchCategory: this.searchCategory,
            });
        },
        openModalExport() {
            // this.modalData = this.currentLocation;
            this.modalData = {
                pricelist_id: this.selectedPriceList,
            };
            this.modalExport = !this.modalExport;
        },
        closeModalExport() {
            this.modalExport = !this.modalExport;
        },
        changePriceList() {
            this.$store.dispatch("getAllPricelists", {
                pricelist_id: this.selectedPriceList,
            });
            this.getAllCategories(this.selectedPriceList, this.user);
        },
    },
};
</script>
